import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import HomePage from './pages/homepage';
import AboutPage from './pages/aboutpage';
import ContactPage from './pages/contactpage';
import ThanksPage from './pages/thanks-page';
import PackagesPage from './pages/packagespage';
import DestinationsPage from './pages/destinations';
import DestinationCategoryPage from './pages/destination-category-page';
import VehiclePage from './pages/vehiclepage';
import CityDetailsPage from './pages/city-details-page';
import CancellationPolicyPage from './pages/cancellationpolicypage';

function App() {
  return (
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<HomePage />} />
          <Route path='/about' element={<AboutPage />} />
          <Route path='/packages' element={<PackagesPage />} />
          <Route path='/destinations' element={<DestinationCategoryPage />} />
          <Route path='/destinations/:category' element={<DestinationsPage />} />
          <Route path='/destinations/:category/:city' element={<CityDetailsPage />} />
          <Route path='/vehicle' element={<VehiclePage />} />
          <Route path='/contact' element={<ContactPage />} />
          <Route path='/thanks' element={<ThanksPage />} />
          <Route path='/cancellation-policy' element={<CancellationPolicyPage />} />
        </Routes>
      </BrowserRouter>
  );
}

export default App;
